module.exports = __webpack_public_path__ + "img/information-unique.d0dd99a.svg";